<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

export default {
  name: 'AddServiceModal',
  components: { BaseModal, LoadingState },
  data() {
    return {
      selectedServices: [],
    };
  },
  computed: {
    serviceList() {
      return this.$store.state.serviceV2.allServices?.map(item => item.service) || [];
    },
    branchId() {
      return this.$route.params.branchId;
    },
    isFetchLoading() {
      return this.$store.state.serviceV2.isAllServicesLoading;
    }
  },
  methods: {
    async fetchServices() {
      try {
        await this.$store.dispatch('serviceV2/fetchAllServices');
      } catch (err) {
        useAlert(`Failed to load services: ${err}`);
        console.error(err);
      }
    },
    async handleConfirm() {
      if (!this.selectedServices.length) {
        useAlert('Please select at least one service.');
        return;
      }

      this.isLoading = true;
      try {
        const payload = {
          branch_id: this.branchId,
          service_ids: this.selectedServices.map(s => s.id),
          update_mode: 'merge',
        };

        await this.$store.dispatch('branchServices/bulkAssignServicesToBranch', payload);
        useAlert('Services added to branch successfully');
        this.$emit('refresh');
        this.$emit('close');
      } catch (error) {
        console.error('Error handling branch:', error);
        useAlert('Failed to add services');
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.fetchServices();
  },
};
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>
      Add Service to Branch
    </template>

    <LoadingState v-if="isFetchLoading" message="Fetching all services..." />

    <form v-if="!isFetchLoading" @submit.prevent="handleConfirm" class="space-y-6">
      <!-- Multiselect for services -->
      <multiselect
        v-model="selectedServices"
        :options="serviceList"
        track-by="id"
        label="name"
        placeholder="Select services"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :show-labels="false"
        :loading="isLoading"
        class="w-full"
      >
        <template #option="{ option }">
          <div class="flex flex-col">
            <span class="font-medium">{{ option.name }}</span>
            <span class="text-xs text-gray-500" v-if="option.description">
              {{ option.description }}
            </span>
          </div>
        </template>
      </multiselect>
    </form>

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')" :disabled="isLoading">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :disabled="isLoading" :loading="isLoading">
          Add
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>